import React from "react";
import "./Home.css";
import { motion } from "framer-motion";
import {
  FaHome,
  FaRocket,
  FaShoppingCart,
  FaHeartbeat,
  FaGraduationCap,
} from "react-icons/fa";

const industries = [
  {
    title: "Real Estate",
    icon: <FaHome />,
    desc: "Smart property platforms, CRM & AI-driven lead generation.",
  },
  {
    title: "Startups",
    icon: <FaRocket />,
    desc: "Scalable MVPs, SaaS products & growth automation systems.",
  },
  {
    title: "E-commerce",
    icon: <FaShoppingCart />,
    desc: "Conversion-focused stores, AI personalization & funnels.",
  },
  {
    title: "Healthcare",
    icon: <FaHeartbeat />,
    desc: "Secure patient systems, telemedicine & automation tools.",
  },
  {
    title: "Education",
    icon: <FaGraduationCap />,
    desc: "LMS platforms, AI tutors & smart learning ecosystems.",
  },
];

const Industries = () => {
  return (
    <div className="backdiv">
    <section className="industries-section">

  
      <div className="industries-left">

  
        <div className="col left-col">
          {industries.slice(0, 3).map((item, index) => (
            <motion.div
              key={index}
              className="industry-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="col right-col">
          {industries.slice(3, 5).map((item, index) => (
            <motion.div
              key={index}
              className="industry-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.3 }}
              viewport={{ once: true }}
            >
              <div className="icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>

      </div>

      <div className="industries-right">
<div>
        <h2 className="main-title">
          Industries We Serve
        </h2>

        <p className="main-text text-center">
          We have worked across multiple industry verticals over the years
          and helped businesses in diverse domains. We have served a wide
          range of industries like Real Estate, Startups,
          E-commerce, Education, Healthcare and many more.
        </p>

</div>
      </div>

    </section>
  
    </div>
  );
};

export default Industries;